import {
  BusFill18Icon,
  CapacitySeatFill18Icon,
} from "@vygruppen/spor-icon-react";
import { Flex, Text } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";

interface BussesPassengersCounterProps {
  vehicles: number;
  passengers: number;
  vehiclesFromMeasureCard: Nullish<number>;
}

export const BussesPassengersCounter = ({
  vehicles,
  passengers,
  vehiclesFromMeasureCard,
}: BussesPassengersCounterProps) => (
  <Flex color="semantics.colorTextSecondary" gap={1.5}>
    <Flex gap={1}>
      <Flex alignItems="center" gap={0.5}>
        <CapacitySeatFill18Icon />
        <Text variant="sm">{passengers}</Text>
      </Flex>

      <Text variant="sm">/</Text>

      <Flex alignItems="center" gap={0.5}>
        <BusFill18Icon />
        <Text variant="sm">{vehicles}</Text>
      </Flex>
    </Flex>

    {vehiclesFromMeasureCard ? (
      <>
        <Text variant="sm">|</Text>
        <Flex gap={1}>
          <Text variant="sm">Tiltakskort:</Text>

          <Flex alignItems="center" gap={0.5}>
            <BusFill18Icon />
            <Text variant="sm">{vehiclesFromMeasureCard}</Text>
          </Flex>
        </Flex>
      </>
    ) : null}
  </Flex>
);
